import React, { Component } from 'react'
import { Card, Icon, Checkbox, Table, Collapse } from 'antd'
import F from '../../Functions'
import axios from 'axios'
import { Translate } from 'react-translated'
import './notification_badphone_email.css'
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import CustomHeader from '../../CommonHeader/CustomHeader';
import Pagination from '../../components/pagination'
import { GET_USER_EMAIL_NOTIFICATIONS, SET_USER_EMAIL_NOTIFICATIONS } from '../../utils/Api_enums'
import { BAD_PHONE_NUMBER, EXTERNAL_RAC, NOTIFICATIONS, WEEKLY_APPOINTMENT_RECAP, WEEKLY_SCORECARD, APPOINTMENT_REMINDER } from '../../utils/Constants'
import AccordionPanel from '../../components/AccordionPanel'

const { Panel } = Collapse;

class Notification_BadPhone_Email extends Component {
  state = {
    associations: [],
    bad_phone: [],
    weekly_appointment_recap: [],
    weekly_score_card: [],
    external_rac: [],
    appointment_reminder: [],
    loading: true,
    loading_email: true,
    checkVariable: false,
    errored: false,
    userTypes: [],
    firstNames: [],
    lastNames: [],
    // filters for header multi-selects
    firstNameFilters: [],
    lastNameFilters: [],
    // shared (legacy) – no longer used for table filtering
    // scoped filters per grid
    firstNameFilters_bad: [],
    lastNameFilters_bad: [],
    firstNameFilters_review: [],
    lastNameFilters_review: [],
    firstNameFilters_score: [],
    firstNameFilters_external: [],
    firstNameFilters_reminder: [],
    lastNameFilters_score: [],
    lastNameFilters_external: [],
    lastNameFilters_reminder: [],
    // pagination per table
    page_bad_phone: 1,
    page_review_email: 1,
    page_scorecard: 1,
    page_external_rac: 1,
    page_appointment_reminder: 1,
    pageSize: 10,
  }


  //LOAD NOTIFICATIONS
  loadBadPhoneNotifications = () => {
    axios
      .get('/api/get_all_user_for_bad_phone_number_notification')
      .then((res) => {
        F.log('Bad Phone Data = > ', res.data.data)
        this.setState({
          bad_phone: res.data.data,
          loading: false,
        })
      })
      .catch((e) => this.setState({ errored: true, loading: false }))
  }


  //WEEKLY APPOINTMENT RECAP
  loadWeeklyAppointmentNotifications = () => {
    axios
      .get(`${GET_USER_EMAIL_NOTIFICATIONS('appointment_recap')}`)
      .then((res) => {
        F.log('Review Email Data = > ', res.data.data)
        this.setState({
          weekly_appointment_recap: res.data.data,
          loading_email: false,
        })
      })
      .catch((e) => this.setState({ errored: true, loading: false }))
  }


  //WEEKLY SCORE CARD
  loadWeeklyScoreCardNotifications = () => {
    axios
      .get(`${GET_USER_EMAIL_NOTIFICATIONS('weekly_scorecard')}`)
      .then((res) => {
        F.log('Review Email Data = > ', res.data.data)
        this.setState({
          weekly_score_card: res.data.data,
          loading: false,
          loading_email: false,
        })
      })
      .catch((e) => this.setState({ errored: true, loading: false }))
  }





  //EXTERNAL Intelligence Link
  loadExternalRACNotifications = () => {
    axios
      .get(`${GET_USER_EMAIL_NOTIFICATIONS('external_rac')}`)
      .then((res) => {
        F.log('Review Email Data = > ', res.data.data)
        this.setState({
          external_rac: res.data.data,
          loading: false,
          loading_email: false,
        });
      })
      .catch((e) => this.setState({ errored: true, loading: false }))
  }

  loadAppointmentReminderNotifications = () => {
    axios
      .get(`${GET_USER_EMAIL_NOTIFICATIONS('appointment_reminder')}`)
      .then((res) => {
        F.log('Appointment Reminder Data = > ', res.data.data)
        this.setState({
          appointment_reminder: res.data.data,
          loading: false,
          loading_email: false,
        });
      })
      .catch((e) => this.setState({ errored: true, loading: false }))
  }


  componentDidMount = () => {
    !this.state.checkVariable &&
      axios
        .get('/api/get_active_associations')
        .then((res) => {
          F.log('Data =>', res.data)
          this.setState({
            associations: res.data,
          })


          const uniqueUserTypes = [...new Set(res.data.map(item => item.user_type))];
          const uniqueFirstNames = [...new Set(res.data.map(item => item.first_name))];
          const uniqueLastNames = [...new Set(res.data.map(item => item.last_name))];
          this.setState({
            userTypes: uniqueUserTypes,
            firstNames: uniqueFirstNames,
            lastNames: uniqueLastNames,
            // initialize filters to all options
            firstNameFilters: uniqueFirstNames,
            lastNameFilters: uniqueLastNames,
            // initialize scoped filters per table
            firstNameFilters_bad: uniqueFirstNames,
            lastNameFilters_bad: uniqueLastNames,
            firstNameFilters_review: uniqueFirstNames,
            lastNameFilters_review: uniqueLastNames,
            firstNameFilters_score: uniqueFirstNames,
            lastNameFilters_score: uniqueLastNames,
            firstNameFilters_external: uniqueFirstNames,
            firstNameFilters_reminder: uniqueFirstNames,
            lastNameFilters_score: uniqueLastNames,
            lastNameFilters_reminder: uniqueLastNames
          });

          axios
            .get('/api/get_all_user_for_bad_phone_number_notification')
            .then((res) => {
              console.log(res.data.data)
              F.log('Bad Phone Data = > ', res.data.data)
              this.setState({
                bad_phone: res.data.data,
              })
            })
            .catch((e) => this.setState({ errored: true, loading: false }));

          axios
            .get(`${GET_USER_EMAIL_NOTIFICATIONS('appointment_recap')}`)
            .then((res) => {
              console.log(res.data.data)
              F.log('review Email = > ', res.data)
              this.setState({
                weekly_appointment_recap: res.data.data,
                loading: false,
                loading_email: false,
              })
            })
            .catch((e) => this.setState({ errored: true, loading: false }));

          axios
            .get(`${GET_USER_EMAIL_NOTIFICATIONS('weekly_scorecard')}`)
            .then((res) => {
              console.log(res.data.data)
              F.log('review Email = > ', res.data)
              this.setState({
                weekly_score_card: res.data.data,
                loading: false,
                loading_email: false,
              })
            })
            .catch((e) => this.setState({ errored: true, loading: false }));



          axios
            .get(`${GET_USER_EMAIL_NOTIFICATIONS('external_rac')}`)
            .then((res) => {
              console.log(res.data.data)
              F.log('review Email = > ', res.data)
              this.setState({
                external_rac: res.data.data,
                loading: false,
                loading_email: false,
              })
            })
            .catch((e) => this.setState({ errored: true, loading: false }));

          axios
            .get(`${GET_USER_EMAIL_NOTIFICATIONS('appointment_reminder')}`)
            .then((res) => {
              console.log(res.data.data)
              F.log('Appointment Reminder Data = > ', res.data)
              this.setState({
                appointment_reminder: res.data.data,
                loading: false,
                loading_email: false,
              })
            })
            .catch((e) => this.setState({ errored: true, loading: false }));
        })
        .catch((e) => {
          this.setState({
            loading: false,
            errored: true,
          });
        });
  }

  onChangeHandleBadPhone = (e) => {
    this.setState({ loading: true })
    axios
      .post('/api/set_user_for_notification_of_bad_phone_number', {
        user_id: e.target.value,
        status: e.target.checked,
      })
      .then((res) => {
        this.loadBadPhoneNotifications()
        this.setState({ checkVariable: true })
      })
  }


  onChangeWeeklyAppointmentRecapEmail = (e) => {
    this.setState({ loading_email: true })
    axios
      .post(`${SET_USER_EMAIL_NOTIFICATIONS}`, {
        user_id: e.target.value,
        status: e.target.checked,
        notification_type: 'appointment_recap'
      })
      .then((res) => {
        this.loadWeeklyAppointmentNotifications()
        this.setState({ checkVariable: true })
      })
  }


  onChangeWeeklyScoreCardEmail = (e) => {
    this.setState({ loading_email: true })
    axios
      .post(`${SET_USER_EMAIL_NOTIFICATIONS}`, {
        user_id: e.target.value,
        status: e.target.checked,
        notification_type: 'weekly_scorecard'
      })
      .then((res) => {
        this.loadWeeklyScoreCardNotifications()
        this.setState({ checkVariable: true })
      })
  }



  onChangeExternalRACEmail = (e) => {
    this.setState({ loading_email: true })
    axios
      .post(`${SET_USER_EMAIL_NOTIFICATIONS}`, {
        user_id: e.target.value,
        status: e.target.checked,
        notification_type: 'external_rac'
      })
      .then((res) => {
        this.loadExternalRACNotifications()
        this.setState({ checkVariable: true })
      })
  }

  onChangeAppointmentReminderEmail = (e) => {
    this.setState({ loading_email: true })
    axios
      .post(`${SET_USER_EMAIL_NOTIFICATIONS}`, {
        user_id: e.target.value,
        status: e.target.checked,
        notification_type: 'appointment_reminder'
      })
      .then((res) => {
        this.loadAppointmentReminderNotifications()
        this.setState({ checkVariable: true })
      })
  }




  render() {

    const {
      associations,
      loading,
      loading_email,
      errored,
      bad_phone,
      weekly_appointment_recap,
      weekly_score_card,
      external_rac,
      userTypes,
      firstNames,
      lastNames
    } = this.state

    // Build table-scoped column defs so funnel selections are isolated per table
    const getColumnDefs = (scope) => [
      {
        headerClass: 'custom-ag-header',
        headerName: 'First Name',
        field: 'first_name',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['First Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'first_name',
          showPopOver: true,
          inputType: "multiCheckbox",
          options: firstNames.map(name => ({ id: name, name })),
          handleFilter: (field, selected) => {
            this.setState({
              page_bad_phone: 1,
              page_review_email: 1,
              page_scorecard: 1,
              page_external_rac: 1
            });
            const next = Array.isArray(selected) && selected.length > 0 ? selected : firstNames;
            // this.setState({ firstNameFilters: next });
            if (scope === 'bad') this.setState({ firstNameFilters_bad: next });
            else if (scope === 'review') this.setState({ firstNameFilters_review: next });
            else if (scope === 'score') this.setState({ firstNameFilters_score: next });
            else if (scope === 'external') this.setState({ firstNameFilters_external: next });
            else if (scope === 'reminder') this.setState({ firstNameFilters_reminder: next });

          }
        }),
        filter: false,
        cellRendererFramework: (params) => (
          <div>{params.data.first_name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Last Name',
        field: 'last_name',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Last Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'last_name',
          showPopOver: true,
          inputType: "multiCheckbox",
          options: lastNames.map(name => ({ id: name, name })),
          handleFilter: (field, selected) => {
            this.setState({
              page_bad_phone: 1,
              page_review_email: 1,
              page_scorecard: 1,
              page_external_rac: 1,
              page_appointment_reminder: 1
            });
            const next = Array.isArray(selected) && selected.length > 0 ? selected : lastNames;
            if (scope === 'bad') this.setState({ lastNameFilters_bad: next });
            else if (scope === 'review') this.setState({ lastNameFilters_review: next });
            else if (scope === 'score') this.setState({ lastNameFilters_score: next });
            else if (scope === 'external') this.setState({ lastNameFilters_external: next });
            else if (scope === 'reminder') this.setState({ lastNameFilters_reminder: next });
          }
        }),
        filter: false,
        cellRendererFramework: (params) => (
          <div>{params.data.last_name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'User Type',
        field: 'user_type',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['User Type'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'user_type',
        }),
        filter: 'agSetColumnFilter',
        filterParams: {
          values: userTypes,
        },
        cellRendererFramework: (params) => (
          <div>{params.data.user_type}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Enable',
        field: 'action',
        minWidth: 120,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Enable'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'action',
        }),
        filter: false,
        cellRendererFramework: (params) => params.data.action,
      },
    ];

    const columnDefsBad = getColumnDefs('bad');
    const columnDefsReview = getColumnDefs('review');
    const columnDefsScore = getColumnDefs('score');
    const columnDefsExternal = getColumnDefs('external');
    const columnDefsReminder = getColumnDefs('reminder');

    const data_bad = [];
    const data_review = [];
    const data_score = [];
    const data_external = [];
    const data_reminder = [];

    // BAD PHONE table data (uses _bad scoped filters)
    for (let i = 0; i < associations.length; i++) {
      const association = associations[i]
      if (
        (this.state.firstNameFilters_bad.length === 0 || this.state.firstNameFilters_bad.includes(association.first_name)) &&
        (this.state.lastNameFilters_bad.length === 0 || this.state.lastNameFilters_bad.includes(association.last_name))
      ) {
        data_bad.push({
          key: i,
          first_name: association.first_name,
          last_name: association.last_name,
          user_type:
            association.user_type === 'EA'
              ? 'Agency Owner'
              : association.user_type === 'LSP'
                ? 'Agency Staff'
                : association.user_type,
          action: (
            <Checkbox
              className="notify_checkbox"
              value={association.id}
              checked={
                bad_phone &&
                  bad_phone.filter((ph) => ph.user_id === association.id).length
                  ? true
                  : false
              }
              onChange={(e) => {
                this.onChangeHandleBadPhone(e)
              }}
            />
          ),
        })
      }
    }

    // REVIEW EMAIL table data (uses _review scoped filters)
    for (let i = 0; i < associations.length; i++) {
      const association = associations[i]
      if (
        (this.state.firstNameFilters_review.length === 0 || this.state.firstNameFilters_review.includes(association.first_name)) &&
        (this.state.lastNameFilters_review.length === 0 || this.state.lastNameFilters_review.includes(association.last_name))
      ) {
        data_review.push({
          key: i,
          first_name: association.first_name,
          last_name: association.last_name,
          user_type:
            association.user_type === 'EA'
              ? 'Agency Owner'
              : association.user_type === 'LSP'
                ? 'Agency Staff'
                : association.user_type,
          action: (
            <Checkbox
              className="notify_checkbox"
              value={association.id}
              checked={
                weekly_appointment_recap &&
                  weekly_appointment_recap.filter((ph) => ph.user_id === association.id).length
                  ? true
                  : false
              }
              onChange={(e) => {
                this.onChangeWeeklyAppointmentRecapEmail(e)
              }}
            />
          ),
        })
      }
    }

    // SCORECARD table data (uses _score scoped filters)
    for (let i = 0; i < associations.length; i++) {
      const association = associations[i]
      if (
        (this.state.firstNameFilters_score.length === 0 ||
          this.state.firstNameFilters_score.includes(association.first_name)) &&
        (this.state.lastNameFilters_score.length === 0 ||
          this.state.lastNameFilters_score.includes(association.last_name))
      ) {
        data_score.push({
          key: i,
          first_name: association.first_name,
          last_name: association.last_name,
          user_type:
            association.user_type === 'EA'
              ? 'Agency Owner'
              : association.user_type === 'LSP'
                ? 'Agency Staff'
                : association.user_type,
          action: (
            <Checkbox
              className="notify_checkbox"
              value={association.id}
              checked={
                weekly_score_card &&
                  weekly_score_card.filter((ph) => ph.user_id === association.id).length
                  ? true
                  : false
              }
              onChange={(e) => {
                this.onChangeWeeklyScoreCardEmail(e)
              }}
            />
          ),
        })
      }
    }



    // EXTERNAL Intelligence Link table data (uses external rac scoped filters)
    for (let i = 0; i < associations.length; i++) {
      const association = associations[i]
      if (
        (this.state.firstNameFilters_external.length === 0 ||
          this.state.firstNameFilters_external.includes(association.first_name)) &&
        (this.state.lastNameFilters_external.length === 0 ||
          this.state.lastNameFilters_external.includes(association.last_name))
      ) {
        data_external.push({
          key: i,
          first_name: association.first_name,
          last_name: association.last_name,
          user_type:
            association.user_type === 'EA'
              ? 'Agency Owner'
              : association.user_type === 'LSP'
                ? 'Agency Staff'
                : association.user_type,
          action: (
            <Checkbox
              className="notify_checkbox"
              value={association.id}
              checked={
                external_rac &&
                  external_rac.filter((ph) => ph.user_id === association.id).length
                  ? true
                  : false
              }
              onChange={(e) => {
                this.onChangeExternalRACEmail(e)
              }}
            />
          ),
        })
      }
    }

    // APPOINTMENT REMINDER table data (uses reminder scoped filters)
    for (let i = 0; i < associations.length; i++) {
      const association = associations[i]
      if (
        (this.state.firstNameFilters_reminder.length === 0 ||
          this.state.firstNameFilters_reminder.includes(association.first_name)) &&
        (this.state.lastNameFilters_reminder.length === 0 ||
          this.state.lastNameFilters_reminder.includes(association.last_name))
      ) {
        data_reminder.push({
          key: i,
          first_name: association.first_name,
          last_name: association.last_name,
          user_type:
            association.user_type === 'EA'
              ? 'Agency Owner'
              : association.user_type === 'LSP'
                ? 'Agency Staff'
                : association.user_type,
          action: (
            <Checkbox
              className="notify_checkbox"
              value={association.id}
              checked={
                this.state.appointment_reminder &&
                  this.state.appointment_reminder.filter((ph) => ph.user_id === association.id).length
                  ? true
                  : false
              }
              onChange={(e) => {
                this.onChangeAppointmentReminderEmail(e)
              }}
            />
          ),
        })
      }
    }







    // paginate data for each table
    const { pageSize, page_bad_phone, page_review_email, page_scorecard, page_external_rac, page_appointment_reminder } = this.state
    const total_pages_bad = Math.ceil(data_bad.length / pageSize) || 0;
    const total_pages_review = Math.ceil(data_review.length / pageSize) || 0;
    const total_pages_score = Math.ceil(data_score.length / pageSize) || 0;
    const total_pages_external = Math.ceil(data_external.length / pageSize) || 0;
    const total_pages_reminder = Math.ceil(data_reminder.length / pageSize) || 0;

    const data_bad_paged = data_bad.slice((page_bad_phone - 1) * pageSize, page_bad_phone * pageSize)
    const data_review_paged = data_review.slice((page_review_email - 1) * pageSize, page_review_email * pageSize)
    const data_score_paged = data_score.slice((page_scorecard - 1) * pageSize, page_scorecard * pageSize)
    const data_external_paged = data_external.slice((page_external_rac - 1) * pageSize, page_external_rac * pageSize)
    const data_reminder_paged = data_reminder.slice((page_appointment_reminder - 1) * pageSize, page_appointment_reminder * pageSize)

    return (
      <Card>
        <Collapse accordion>
          {/* 1. Bad Phone Numbers */}
          <Panel
            key="bad-phone"
            header={
              <div style={{ paddingTop: 7 }}>
                <Icon type="bell" style={{ marginRight: 10 }} />
                <Translate text={`${BAD_PHONE_NUMBER} ${NOTIFICATIONS}`} />
              </div>
            }
          >
            <AccordionPanel
              panelKey="bad-phone"
              loading={loading}
              rowDatas={data_bad_paged}
              columnDefs={columnDefsBad}
              currentPage={this.state.page_bad_phone}
              totalPages={total_pages_bad}
              onPageChange={(page) => this.setState({ page_bad_phone: page })}
            />
          </Panel>

          {/* 2. Weekly Appointment Recap */}
          <Panel
            key="weekly-appointment"
            header={
              <div style={{ paddingTop: 7 }}>
                <Icon type="bell" style={{ marginRight: 10 }} />
                <Translate text={`${WEEKLY_APPOINTMENT_RECAP} ${NOTIFICATIONS}`} />
              </div>
            }
          >
            <AccordionPanel
              panelKey="weekly-appointment"
              loading={loading_email}
              rowDatas={data_review_paged}
              columnDefs={columnDefsReview}
              currentPage={this.state.page_review_email}
              totalPages={total_pages_review}
              onPageChange={(page) => this.setState({ page_review_email: page })}
            />
          </Panel>

          {/* 3. Weekly Scorecard */}
          <Panel
            key="weekly-scorecard"
            header={
              <div style={{ paddingTop: 7 }}>
                <Icon type="bell" style={{ marginRight: 10 }} />
                <Translate text={`${WEEKLY_SCORECARD} ${NOTIFICATIONS}`} />
              </div>
            }
          >
            <AccordionPanel
              panelKey="weekly-scorecard"
              loading={loading_email}
              rowDatas={data_score_paged}
              columnDefs={columnDefsScore}
              currentPage={this.state.page_scorecard}
              totalPages={total_pages_score}
              onPageChange={(page) => this.setState({ page_scorecard: page })}
            />
          </Panel>

          {/* 4. External Intelligence Link */}
          <Panel
            key="external-rac"
            header={
              <div style={{ paddingTop: 7 }}>
                <Icon type="bell" style={{ marginRight: 10 }} />
                <Translate text={`${EXTERNAL_RAC} ${NOTIFICATIONS}`} />
              </div>
            }
          >
            <AccordionPanel
              panelKey="external-rac"
              loading={loading_email}
              rowDatas={data_external_paged}
              columnDefs={columnDefsExternal}
              currentPage={this.state.page_external_rac}
              totalPages={total_pages_external}
              onPageChange={(page) => this.setState({ page_external_rac: page })}
            />
          </Panel>

          {/* 5. Appointment Reminder Emails */}
          <Panel
            key="appointment-reminder"
            header={
              <div style={{ paddingTop: 7 }}>
                <Icon type="bell" style={{ marginRight: 10 }} />
                <Translate text={`${APPOINTMENT_REMINDER} ${NOTIFICATIONS}`} />
              </div>
            }
          >
            <AccordionPanel
              panelKey="appointment-reminder"
              loading={loading_email}
              rowDatas={data_reminder_paged}
              columnDefs={columnDefsReminder}
              currentPage={this.state.page_appointment_reminder}
              totalPages={total_pages_reminder}
              onPageChange={(page) => this.setState({ page_appointment_reminder: page })}
            />
          </Panel>
        </Collapse>
      </Card>
    )
  }
}

export default Notification_BadPhone_Email






// WEBPACK FOOTER //
// ./src/scenes/Notifications/notification_badphone_email.js